export default __webpack_public_path__ + "static/media/qualityTraceability.d747d176.jpg";